import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import {endpoints} from "@api/apis";

export const kycPhotoGetPresignedURL = async (payload: {
    applicationId: string,
    imageType: string,
    imageName: string
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    return await axios.post(`${endpoints.kycPhotoUploadPreSignedURL}`, {
        applicationId: applicationId,
        imageType: payload.imageType,
        imageName: payload.imageName
    }, {
        headers: {
            handleFromMF: true
        }
    });

}

export const kycUploadPhotoToS3 = async (payload: {
    preSignedURL: string,
    imageBody: any
}): Promise<'success' | 'failure'> => {
    const response = await fetch(payload.preSignedURL, {
        method: 'PUT',
        headers: {
            'Content-Type': 'image/jpeg'
        },
        body: payload.imageBody
    })
    if (response.ok) {
        return "success"
    } else {
        return "failure"
    }
}

export const kycPhotoVerify = async (payload: {
    applicationId: string,
}) => {
    const applicationIdStored = await AsyncStorage.getItem("application_id")
    const applicationId = applicationIdStored ?? payload.applicationId
    return await axios.post(`${endpoints.kycPhotoVerify}`, {
        applicationId: applicationId,
    });
}